import { lazaiTestnet } from '@/common-helpers/lazaiTestnetChain';
import { Chain } from 'wagmi/chains';
export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';

export enum ChainId {
    lazaiTestnet = 133718,
}

export const MainnetOnly = Number(import.meta.env.VITE_MAINNET_ONLY) === 1;

export const DefaultChainId = ChainId.lazaiTestnet;

export const SupportChainIDs = [ChainId.lazaiTestnet];

export const ProviderSupportChainId: Chain[] = [lazaiTestnet];

export const NETWORK_CONFIG = {
    [ChainId.lazaiTestnet]: {
        name: 'LazAI Testnet',
        scanLable: 'LazAI Testnet',
        explore: 'https://testnet-explorer.lazai.network/',
    },
};

export const SWITCH_NETWORK_CONFIG = {
    [ChainId.lazaiTestnet]: {
        chainId: `0x${ChainId.lazaiTestnet.toString(16)}`,
        chainName: 'LazAI Testnet',
        nativeCurrency: {
            name: 'LazAI Testnet',
            symbol: 'LAZAI',
            decimals: 18,
        },
        rpcUrls: [`https://testnet.lazai.network`],
        blockExplorerUrls: ['https://testnet-explorer.lazai.network'],
    },
};

export const RPC = {
    [ChainId.lazaiTestnet]: 'https://testnet.lazai.network',
};

export type Token = {
    name: string;
    symbol: string;
    decimals: number;
    address: string;
    img?: string;
};

export enum FaucetToken {
    lazai = 'lazai',
}

export const ENCRYPTION_SEED = 'Sign to retrieve your encryption key';

export const DATA_REGISTRY_CONTRACT_ADDRESS =
    '0xE7753EeBCA82849D6b19E6689B350f87318A8998';

export const DATA_VERIFIED_COMPUTING_CONTRACT_ADDRESS =
    '0x87E43F24Efc2284fd2BBF11CC80d6fcF3E0AD474';

export const APP_TOKEN = 'corruption_ai_tg_app';
